import { PrimaryCourseAction, QuietLine, WithdrawnNotice } from "@/components/courses/workspace/WorkspacePrimitives";
import { Tile, TileHeader } from "@/components/ui/tile";
import { WidgetHeading } from "@/components/workspace/WidgetHeading";

/**
 * The home grammar uses the same surfaces and heading owner as real seats: the
 * one ranked act as the lead tile, then the work row of widgets on the bento.
 */
export function SeatHomeSpecimen({ idPrefix }: { idPrefix: string }) {
  return (
    <section aria-labelledby={`${idPrefix}-home-specimen`} className="grid gap-[var(--layout-bento-gap)]" data-seat-home-specimen>
      <div className="grid gap-1">
        <p className="eyebrow">Seat homes</p>
        <h2 id={`${idPrefix}-home-specimen`} className="text-tile-title font-semibold">One next action, quiet supporting widgets</h2>
        <p className="text-ui text-muted-foreground">The server chooses the next action. Teaching, learning, and registrar homes preserve their own reading order and authority.</p>
      </div>
      <Tile aria-labelledby={`${idPrefix}-home-next`} data-workspace-weight="lead" className="flex-row flex-wrap items-center gap-x-5 gap-y-3">
        <div className="min-w-0 flex-1">
          <TileHeader id={`${idPrefix}-home-next`} as="h3" title="Your next session" />
          <p className="text-ui text-muted-foreground">ARAB-301 · Advanced Arabic Rhetoric and the Classical Commentaries</p>
        </div>
        <PrimaryCourseAction action={{ label: "Open session", href: `#${idPrefix}-home-next`, reason: "open_ranked_exact_class" }} />
      </Tile>
      <div className="grid gap-[var(--layout-bento-gap)] xl:grid-cols-12">
        <Tile aria-labelledby={`${idPrefix}-home-current`} className="gap-3 xl:col-span-8">
          <WidgetHeading id={`${idPrefix}-home-current`} meta="Session times in New York">Your courses</WidgetHeading>
          <div className="grid gap-0.5 border-t border-rule pt-3">
            <p className="text-ui font-medium text-foreground">Principles of Fiqh</p>
            <p className="text-meta text-muted-foreground">Next session · Tuesday at 6:30 PM</p>
          </div>
        </Tile>
        <Tile aria-labelledby={`${idPrefix}-home-record`} className="gap-3 xl:col-span-4">
          <TileHeader id={`${idPrefix}-home-record`} as="h3" title="Released feedback" />
          <QuietLine>No newly released feedback.</QuietLine>
        </Tile>
      </div>
      <WithdrawnNotice>Coursework could not be read. No count or completion is inferred.</WithdrawnNotice>
    </section>
  );
}
